<template>
  <div class="container text-start">
    <div class="d-flex justify-content-between">
      <span class="h3 fw-bold">Admin </span>
      <span class="my-2">Public Key: {{ publicKey }}</span>
    </div>
    <AdminTable :entries="getAdminEntries" />
    <div class="row">
      <div class="col">
        <AdminExport :entries="getAdminEntries" />
      </div>
      <div class="col">
        <AdminReset />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import DatastoreAPI from "@/helpers/DatastoreAPI";

import AdminTable from "@/components/admin/AdminTable";
import AdminExport from "@/components/admin/AdminExport";
import AdminReset from "@/components/admin/AdminReset";

export default {
  name: "AdminView",
  mixins: [DatastoreAPI],
  components: {
    AdminTable,
    AdminExport,
    AdminReset
  },
  computed: {
    ...mapGetters("datastore", ["getAdminEntries"]),
    publicKey() {
      return process.env.VUE_APP_PUBLIC_KEY;
    }
  },
  created() {
    this.readEntries();
  }
};
</script>
